import security from './security';
import jwtHelper from '../jwt/jwtHelper';

export default (store) => (next) => (action) => {
    if (action.shouldNotCheckAuthentication) {
        return next(action);
    }

    const hasToken = !!security.getToken();
    const isAuthorized = security.isAuthorized();

    if (!hasToken) {
        return next(action);
    }

    if (isAuthorized) {
        return next(action);
    }

    const hasRefreshToken = !!jwtHelper.getRefreshToken();
    if (hasRefreshToken) {
        console.log('[Security Middleware] Has refresh token, allowing action - will let axios interceptor handle refresh', {
            actionType: action.type,
            hasToken,
            isAuthorized,
            hasRefreshToken
        });
        return next(action);
    }
};
